import $ from "jquery";

export const getScreenWidth = () => {
  let w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    width = w.innerWidth || e.clientWidth || g.clientWidth;

  return width;
};

export const getScreenHeight = () => {
  let w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    height = w.innerHeight || e.clientHeight || g.clientHeight;

  return height;
};

export const isMobile = () => {
  if (getScreenWidth() <= 1260) return true;
};

export const isPhone = () => {
  if (getScreenWidth() <= 440) return true;
};

export const getCoords = elem => {
  let box = elem.getBoundingClientRect();

  let body = document.body;
  let docEl = document.documentElement;

  let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  let clientTop = docEl.clientTop || body.clientTop || 0;
  let clientLeft = docEl.clientLeft || body.clientLeft || 0;

  let top = box.top + scrollTop - clientTop;
  let left = box.left + scrollLeft - clientLeft;

  return { top: Math.round(top), left: Math.round(left) };
};

export const createCookie = (name, value, minutes) => {
  let expires = "";
  if (minutes) {
    let date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
};

export const readCookie = name => {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const eraseCookie = name => {
  createCookie(name, "", -1);
};

export const handleVideo = elem => {

  const videoTrigger = elem.querySelector('.video-thumbnail');
  const closeButton = elem.querySelector('.close');

  videoTrigger.addEventListener('click', () => showVideoPopup(elem));
  closeButton.addEventListener('click', (e) => hideVideoPopup(e.target.closest('.video-popup-container')));

  $(window).on('keydown', function(e){
    if (e.keyCode == 27 || e.which == 27) {
      hideAllVideoPopups();
    }
  });
  
  function hideAllVideoPopups(){
    let popups = $('.video-popup-container');

    $.each(popups, function(i, pop){
      hideVideoPopup(pop);
    });
  }

  function hideVideoPopup(popup) {
    let iframe = $(popup).find('iframe');
    let video = popup.querySelector('video');
    
    if (iframe[0]) {
      iframe[0].removeAttribute('src');
    }

    if (video) {
      video.pause();
    }

    elem.classList.remove('shown');

    setTimeout(function() {
      $(popup).stop().fadeOut();
    }, 100);
  }

  function showVideoPopup(elem) {
    let popup = $(elem).find('.video-popup-container');
    let video = elem.querySelector('video');
    let iframe = $(elem).find('iframe');

    elem.classList.add('shown');
    popup.stop().fadeIn();

    if (video) {
      video.play();
    }

    if (iframe[0]) {
      let src = iframe.attr('data-src');
      src += "&autoplay=1";
      iframe[0].src = src;
    }
  }
};